import script from "./CampaignDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CampaignDetailPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__